import React from 'react';
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../../component/Page/Page";
import IntegrationUserForm from "./component/IntegrationUserForm";

class IntegrationUserFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Cadastros"/>,
      <BreadcrumbItem key={2} title="Lista de usuários" to="/list/users"/>,
      < BreadcrumbItem key={3} title="Dados do usuário" active={true}/>];
    return (
        <Page title="Dados do Usuário de Integração" breadcrumbs={breadcrumbs}>
          <IntegrationUserForm match={match} history={history}/>
        </Page>
    );
  }
}

export default IntegrationUserFormPage;



// WEBPACK FOOTER //
// ./src/user/integration/IntegrationUserFormPage.js